var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 10.6666C1.33331 8.78101 1.33331 7.8382 1.9191 7.25241C2.50489 6.66663 3.44769 6.66663 5.33331 6.66663H10.6666C12.5523 6.66663 13.4951 6.66663 14.0809 7.25241C14.6666 7.8382 14.6666 8.78101 14.6666 10.6666C14.6666 12.5522 14.6666 13.4951 14.0809 14.0808C13.4951 14.6666 12.5523 14.6666 10.6666 14.6666H5.33331C3.44769 14.6666 2.50489 14.6666 1.9191 14.0808C1.33331 13.4951 1.33331 12.5522 1.33331 10.6666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66671V5.33337C4 3.12424 5.79086 1.33337 8 1.33337C9.86384 1.33337 11.4299 2.60815 11.874 4.33337",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 10.6666H5.33931M7.99398 10.6666H7.99998M10.6606 10.6666H10.6666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1156_10444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.33d0264d763aa1d6137ccd2cf024fef3.svg";
export { ForwardRef as ReactComponent };